/**
 * Chart titles for the exported deck.
 *
 * The deck is Dutch-only and carries no i18n, so its titles have to be
 * literals — but holding them as loose strings next to each chart is what let
 * them drift from the dashboard once already. Keyed by the translation key of
 * the chart they title, so `chartTitles.test.ts` can pin each one to the nl
 * translation and fail the build if a screen rename is not mirrored here.
 *
 * Keep the values byte-identical to nl/translations.json.
 */
export const CHART_TITLES: Record<string, string> = {
  'cpi.analytics.emissionsByMonth': 'CO₂e totaal per maand (kg)',
  'cpi.analytics.intensityPerTon': 'CO₂e per ton (kg) WTW',
  'cpi.analytics.intensityPerTonKm': 'CPI',
  'cpi.analytics.intensityByVehicle': 'Top 10 CO₂e per voertuig (kg/ton·km)',
  'cpi.analytics.intensityByOrder': 'Top 10 CO₂e per order (kg/ton·km)',
  'cpi.analytics.intensityByModality': 'CO₂e per modaliteit (kg/ton)',
  'cpi.analytics.weightByModality': 'Gewicht per Modaliteit (ton)',
};
